/*
 * Porto v4.1.0 tab-nav + datepicker customizations re-applied on top of pristine v4.3.0.
 *
 * Source: project's pre-refactor public/js/theme.js and public/js/theme.init.js.
 * Audit doc: docs/superpowers/plans/2026-05-13-porto-audit.md.
 *
 * Why an extension (and not a surgical patch on theme.js)?
 *   The audit calls out that the tab-nav method body shifted between 4.1.0 and 4.3.0,
 *   so applying the original +19/-6 hunk surgically is fragile. The 3 behaviors below
 *   re-implement what the project added without touching the base file.
 *
 * Behaviors carried over:
 *   1) Scroll-snap-to-tab — when a tab is shown and the tab-nav is out of view, scroll to it.
 *   2) Auto-hide tab-nav once scrolled past it, expose a `.toggle-menu-button`.
 *   3) Clicking the toggle-menu-button scrolls back to the tab-nav.
 *   4) Disable all dates in Porto's datepicker plugin theme by default.
 */

(function () {
    'use strict';

    function initTabNavExtension() {
        var $ = window.jQuery;
        if (!$) return;

        var $tabNav = $('.tab-nav');
        if (!$tabNav.length) return;

        var $window = $(window);
        var $toggleMenuButton = $('.toggle-menu-button');
        var navStartTop = $tabNav.offset() ? $tabNav.offset().top : 0;

        /* (1) Scroll-snap-to-tab: when a tab is shown and the nav is out of viewport,
                animate scrollTop so the tab-nav lines up near the page top. */
        $tabNav.find('a[data-bs-toggle="tab"], a[data-toggle="tab"]').on('shown.bs.tab', function () {
            if (!$tabNav.offset()) return;
            var top = $tabNav.offset().top;
            var scrollTop = $window.scrollTop();
            if (scrollTop < top - 20 || scrollTop > top + 200) {
                $('html, body').animate({ scrollTop: top - 20 }, 300);
            }
        });

        /* (2) Auto-hide tab-nav once scrolled past its starting position. */
        $window.on('scroll.almcTabNav', function () {
            var passed = $window.scrollTop() > navStartTop + $tabNav.outerHeight();
            $tabNav.toggleClass('tab-nav-hidden', passed);
            $toggleMenuButton.toggleClass('visible', passed);
        });

        /* (3) Toggle-menu-button click: scroll back to the tab-nav. */
        $toggleMenuButton.on('click.almcTabNav', function () {
            if (!$tabNav.offset()) return;
            $('html, body').animate({ scrollTop: $tabNav.offset().top - 20 }, 300);
        });
    }

    function initDatepickerOverride() {
        /* (4) Disable all dates by default in Porto's datepicker plugin theme.
               This was a single-line override in the project's public/js/theme.init.js. */
        if (window.theme && window.theme.PluginDatepicker && window.theme.PluginDatepicker.defaults) {
            window.theme.PluginDatepicker.defaults.beforeShowDay = function () { return false; };
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            initTabNavExtension();
            initDatepickerOverride();
        });
    } else {
        initTabNavExtension();
        initDatepickerOverride();
    }
})();
